import styles from "./policy.module.css";
import anex1 from "./1.jpg";
import anex2 from "./2.jpg";
const TermsAndConditions = () => {
  return (
    <div className={styles["terms-container"]}>
      <p style={{ fontFamily: "Comfortaa", fontSize: "16px" }}>
        <h1>
          <span>TERMS OF USE</span>
        </h1>
        Welcome to Sekeron! These Terms of Use (or &quot;Terms&quot;) govern
        your use of Sekeron. When you create an account on Sekeron or use
        Sekeron, you agree to these Terms. These Terms of Use therefore
        constitute an agreement between you and Sekeron.
        <h2>The Sekeron Service:</h2>
        We agree to provide you with the Sekeron Service. The Service includes
        all of the Sekeron features, services, technologies and software that we
        provide to display and explore artistic talents. The service is made up
        of the following aspects:
        <h3>
          • Offering personalized opportunities to create, connect, communicate,
          discover and share:
        </h3>
        We offer creation of an user account along with various other features
        to help you create, share, grow your presence and communicate with
        people on and off Sekeron. On Sekeron, users have an opportunity to
        create their own projects or can join the other projects and display
        their talents. Also, Sekeron gives an opportunity to the users to build
        their own profile and display their artistic work to the world.
        <h3>• Fostering a positive, inclusive and safe environment:</h3>
        We develop and use tools and offer resources to our community members
        that help to make their experiences positive and inclusive, including
        when we think that they might need help. We also have teams and systems
        that work to combat abuse and breaches of our Terms and policies, as
        well as harmful and deceptive behaviour. We use all of the information
        that we have – including your information – to try to keep our platform
        secure. Learn more in the Privacy Policy.
        <h3>
          • Developing and using technologies that help us consistently serve
          our growing community:
        </h3>
        Organising and analysing information for our growing community is
        central to our Service. A big part of our Service is creating and using
        cutting-edge technologies that help us personalise, protect and improve
        our Service on an incredibly large scale for a broad global community.
        <h3>• Ensuring access to our service:</h3>
        To operate our global Service, we must store and transfer data across
        our systems around the world, including outside of your country of
        residence. The use of this global infrastructure is necessary and
        essential to provide our Service. This infrastructure may be owned or
        operated by the relevant service providers.
        <h3>• Research and innovation:</h3>
        We use the information we have to study our Service and collaborate with
        others on research to make our Service better and contribute to the
        well- being of our community.
        <h3>• Providing Assistance for Collaboration:</h3>
        As one of the key features of the Sekeron, the artists can collaborate
        with each other for the purpose of the project/event. To facilitate this
        collaboration, the Sekeron provides the Collaboration Agreement, wherein
        rights of the project initiator, artists and other members are
        specified. The Collaboration Agreement can be amended as per the consent
        of the parties. Sekeron is not a party to the Collaboration Agreement
        and is only facilitating this contract via technology and the agreement
        is governed by the Collaboration Policy to protect the user copyrights.
        <h2>The Privacy Policy:</h2>
        Providing our Service requires collecting and using your information.
        The Privacy Policy explains how we collect, use and share information.
        It also explains the many ways in which you can control your
        information. You must agree to the Privacy Policy to use Sekeron.
        <h3>Your commitments</h3>
        In return for our commitment to provide the Service, we require you to
        make the below commitments to us.
        <h5>I. Who can use Sekeron ?</h5>
        We want our Service to be as open and inclusive as possible, but we also
        want it to be safe, secure and in accordance with the law. So, we need
        you to commit to a few restrictions in order to be part of the Sekeron.
        <li>
          You must be at least of the legal age in your country to use Sekeron.
        </li>
        <li>
          You must not be prohibited from receiving any aspect of our Service
          under applicable laws.
        </li>
        <li>
          We must not have previously disabled your account for violation of law
          or any of our policies.
        </li>
        <li>You must not be convicted sex offender.</li>
        <h5>II. How you cannot use Sekeron?</h5>
        <li>
          You can’t impersonate others or provide inaccurate information. You
          don't have to disclose your identity on Sekeron, but you must provide
          us with accurate and up-to-date information (including registration
          information), which may include providing personal data. Also, you may
          not impersonate someone or something you aren't, and you can't create
          an account for someone else unless you have their express permission.
        </li>
        <li>
          You can't do anything unlawful, misleading or fraudulent or for an
          illegal or unauthorised purpose.
        </li>
        <li>
          You can't violate (or help or encourage others to violate) these Terms
          or our policies, including in particular the Community Guidelines,
          Collaboration Policy or any other policy of the Sekeron as updated
          from time to time.
        </li>
        <li>
          You can't do anything to interfere with or impair the intended
          operation of the Service. This includes misusing any reporting,
          dispute or appeals channel, such as by making fraudulent or groundless
          reports or appeals.
        </li>
        <li>
          You can't attempt to create accounts or access or collect information
          in unauthorised ways. This includes creating accounts or collecting
          information in an automated way without our express permission.
        </li>
        <li>
          You can't sell, license or purchase any account or data obtained from
          us or our Service. This includes attempts to buy, sell or transfer any
          aspect of your account (including your username); solicit, collect or
          use login credentials or badges of other users; or request or collect
          Sekeron usernames, passwords or misappropriate access tokens.
        </li>
        <li>
          You can&#39;t post someone else&#39;s private or confidential
          information without permission or do anything that violates someone
          else&#39;s rights, including intellectual property rights (e.g.
          copyright infringement, trademark infringement, counterfeit or pirated
          goods).You may use someone else&#39;s works under exceptions or
          limitations to copyright and related rights under applicable law. You
          represent that you own or have obtained all necessary rights to the
          content you post or sharee
        </li>
        <li>
          You can't modify, translate, create derivative works of or reverse-
          engineer our products or their components.
        </li>
        <li>
          You can't use a domain name or URL in your username without our prior
          written consent.
        </li>
        <h3>Permission you give to us:</h3>
        As a part of our agreement, you also give us permissions that we need to
        provide the service.
        <h4>
          • We do not claim ownership of your content, but you grant us a
          licence to use it.
        </h4>
        Nothing is changing about your rights in your content. We do not claim
        ownership of your content that you post on or through the Service and
        you are free to share your content with anyone else, wherever you
        choose. However, we need certain legal permissions from you (known as a
        "licence") to provide the Service. When you share, post or upload
        content that is covered by intellectual property rights (such as photos
        or videos) on or in connection with our Service, you hereby grant to us
        a non-exclusive, royalty-free, transferable, sublicensable, worldwide
        licence to host, use, distribute, modify, run, copy, publicly perform or
        display, translate and create derivative works of your content
        (consistent with your privacy and application settings).
        <h4>
          • Permission to use your username, profile picture and information
          about your relationships and actions with accounts, ads and sponsored
          content.
        </h4>
        You give us permission to show your username, profile picture and
        information about your actions (such as likes) or relationships (such as
        follows) next to or in connection with accounts, ads, offers and other
        sponsored content that you follow or engage with that are displayed on
        Sekeron, without any compensation to you. For example, we may show that
        you liked a sponsored post created by a brand that has paid us to
        display its ads on Sekeron. • You agree that we can download and install
        updates to the Service on your device.
        <h3>Additional rights we retain:</h3>
        <li>
          If you select a username or similar identifier for your account, we
          may change it if we believe it is appropriate or necessary (for
          example, if it infringes someone's intellectual property or
          impersonates another user).
        </li>
        <li>
          If you use content covered by intellectual property rights that we
          have and make available in our Service (for example, images, designs,
          videos or sounds we provide that you add to content you create or
          share), we retain all rights to our content (but not yours).
        </li>
        <li>
          You must obtain written permission from us or under an open-source
          licence to modify, create derivative works of, decompile or otherwise
          attempt to extract source code from us.
        </li>
        Content removal and disabling or terminating your account
        <li>
          We can remove any content or information that you share on the Service
          if we believe that it violates these Terms of Use, our policies
          (including our Community Guidelines) or we are permitted or required
          to do so by law. We can refuse to provide or stop providing all or
          part of the Service to you immediately to protect our community or
          services, or if you create risk or legal exposure for us, violate
          these Terms of Use or our policies (including our Community
          Guidelines), if you repeatedly infringe other people's intellectual
          property rights, or where we are permitted or required to do so by
          law. We can also terminate or change the Service, remove or block
          content or information shared on our Service, or stop providing all or
          part of the Service if we determine that doing so is reasonably
          necessary to avoid or mitigate adverse legal or regulatory impacts on
          us. If you believe that your account has been terminated in error, or
          you want to disable or permanently delete your account, information
          can be found in FAQs or you can contact us.
        </li>
        <h3>How we will handle disputes.</h3>
        If you are a consumer, the laws of the country in which you reside will
        apply to any claim, cause of action or dispute that you have against any
        other user on Sekeron and you may resolve your claim in any competent
        court in that country that has jurisdiction over the claim. In all other
        cases, specifically with respect to claims against Sekeron, you agree
        that the claim must be resolved exclusively under the jurisdiction of
        courts in New Delhi, India and that the laws of India will govern these
        Terms and any claim, without regard to conflict of law provisions.
        Without prejudice to the foregoing, you agree that, in its sole
        discretion, Sekeron may also bring any claim that we have against you
        related to efforts to abuse, interfere or engage with our products in
        unauthorised ways in the courts of New Delhi, India.
        <h3>Updating these Terms</h3>
        We may change our Service and Policies, and we may need to make changes
        to these Terms so that they accurately reflect our Service and Policies.
        Unless otherwise required by law, we will notify you (for example,
        through our Service) before we make changes to these Terms and give you
        an opportunity to review them before they go into effect. Then, if you
        continue to use the Service, you will be bound by the updated Terms. If
        you do not want to agree to these or any updated Terms, you can delete
        your account <a href="https://sekeron.com/data-deletion-policy">here</a>
        .
      </p>
    </div>
  );
};

const CollaborationPolicy = () => {
  return (
    <div className={styles["collaboration-policy-container"]}>
      <p style={{ fontFamily: "Comfortaa", fontSize: "16px" }}>
        <h1>
          <span>COLLABORATION POLICY</span>
        </h1>
        <h2 style={{ textAlign: "center" }}>
          <span>TABLE OF CONTENTS</span>
        </h2>
        <h4
          style={{
            fontWeight: "bold",
            textDecoration: "underline",
            fontSize: "2rem",
            marginTop: "2rem",
          }}
        >
          Clause
        </h4>
        <ul style={{ marginLeft: "6rem", marginTop: "2rem" }}>
          <li style={{ listStyleType: "decimal" }}>Definitions</li>
          <li style={{ listStyleType: "decimal" }}>General Term</li>
          <li style={{ listStyleType: "decimal" }}>Scope of Collaboration</li>
          <li style={{ listStyleType: "decimal" }}>Grant of License </li>
          <li style={{ listStyleType: "decimal" }}>
            Rights of the Administrator
          </li>
          <li style={{ listStyleType: "decimal" }}>IPR</li>
          <li style={{ listStyleType: "decimal" }}>
            Flow of Collaboration
            <ul style={{ marginLeft: "3rem" }}>
              <li style={{ listStyleType: "disc" }}>Creation of Project</li>
              <li style={{ listStyleType: "disc" }}>
                Adding and Inviting of Artist
              </li>
              <li style={{ listStyleType: "disc" }}>Exit of Collaborator(s)</li>
              <li style={{ listStyleType: "disc" }}>Amendment</li>
              <li style={{ listStyleType: "disc" }}>Conclusion of Project</li>
            </ul>
          </li>
          <li style={{ listStyleType: "decimal" }}>
            Termination of Collaboration Agreement
          </li>
          <li style={{ listStyleType: "decimal" }}>
            Non-Disclosure Undertaking
          </li>
        </ul>
        <p style={{ marginTop: "3rem" }}>
          Sekeron is a social media web and mobile application (Hereinafter
          shall be referred to as <strong>“Sekeron”</strong>) created for
          artists of all disciplines to improvise communication and
          collaboration among the creative community. With a vibrant and
          supportive community, it serves as an intermediary which provides an
          inspiring space where artists can connect, share ideas, and
          collaborate seamlessly on diverse art projects. Whether painters,
          photographers, musicians, writers, or any creative mind, Sekeron
          empowers artists to unleash their creativity and explore new artistic
          horizons together. Sekeron encourages an engaging and ever- expanding
          network of collaborative artists, fostering innovation and artistic
          growth.
        </p>
        <p>
          On Sekeron, users can register themselves and use various features of
          the app like creating a project, uploading posts, messaging other
          users, etc. One of the main purposes of Sekeron is to ensure smooth
          collaboration between artists and hence, Sekeron has created features
          to facilitate such collaborations and to that effect, this
          collaboration policy (hereinafter shall be referred as{" "}
          <strong>“Collaboration Policy”</strong> or <strong>“Policy”</strong>)
          has been curated for simplifying the user experience.
        </p>
        <p>
          The scope of Collaboration Policy for artists broadly encompasses the
          collaborative activities, roles, and goals. It includes creative
          projects, delineating roles and responsibilities, setting a timeline,
          addressing intellectual property rights, handling financial
          considerations, specifying termination and various other aspects. The
          same is elucidated upon further in Clause 3 of Policy.
        </p>
        <p>
          The events of collaboration will be governed by the key terms and
          conditions of Collaboration Policy, which are described as follows:
        </p>

        <h3>1. Definitions:</h3>
        <ol style={{ listStyleType: "lower-alpha", marginLeft: "3rem" }}>
          <li style={{ listStyleType: "lower-alpha", marginTop: "3rem" }}>
            COLLABORATION:
            <p>
              The term refers to a mutually beneficial working relationship
              between two or more artists which involves the artists coming
              together to jointly create, produce, or perform artistic works,
              projects, or events in order to achieve a common artistic goal.
            </p>
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            COLLABORATOR/ PARTIES:
            <p>
              The term refers to the individuals or entities who are actively in
              the collaboration project and forms part of Collaboration
              Agreement. These collaborator(s) work together, sharing their
              creative ideas, skills and resourced, with the common goal of
              creating a joint artistic work or achieving a specific artistic
              outcome.
            </p>
          </li>
          <li>
            COLLABORATION AGREEMENT or AGREEMENT:
            <p>
              It refers to an Agreement based on the Collaboration Policy
              entered between the Collaborators to outline the terms and
              conditions of the Project.
            </p>
          </li>
          <li>
            COLLABORATION SCHEDULE:
            <p>
              It refers to the agreed timeline or timetable for completing the
              collaborative project or tasks. It outlines the specific dates,
              deadlines, and milestones associated with the collaboration and
              serves as a roadmap for the artists involved. It would typically
              include important dates such as the starting date, deadline(s),
              milestones, meetings or check-ins, feedback periods, the final
              completion date, etc.
            </p>
          </li>
          <li>
            CO-OWNER/ JOINT OWNERSHIP:
            <p>
              In some cases, the collaborators may agree to share joint
              ownership of the project, meaning that all parties involved have
              an equal or unequal stake in the work and share the rights and
              responsibilities associated with it. Joint ownership often
              requires unanimous agreement on decisions related to the project
              and may involve revenue sharing.
            </p>
          </li>
          <li>
            CUSTOMIZED OWNERSHIP ARRANGEMENTS (CO-OWNER WITH EQUAL OR UNEQUAL
            SPLIT):
            <p>
              The collaborators may also create a customized ownership
              arrangement based on their specific needs and goals. For instance,
              they could agree to assign ownership based on specific
              contributions or allocate ownership percentages according to each
              collaborator's level of involvement or investment in the project.
            </p>
          </li>
          <li>
            EX-COLLABORATOR:
            <p>
              The term refers to a Collaborator who is not anymore part of the
              Collaboration for whatsoever reason.
            </p>
          </li>
          <li>
            PROJECT:
            <p>
              In a collaborative art project, a “Project” is typically defined
              as a specific creative endeavor or undertaking that involves the
              collective efforts of multiple individuals working together to
              achieve a common artistic goal. This could encompass a wide range
              of artistic disciplines, such as visual arts, performing arts,
              literature, music, film, digital media, and more.
            </p>
          </li>
          <li>
            PROJECT NAME:
            <p>
              Simply defined as the name/title of the Project, which, however,
              is not limited by its extent and may be amended in due course of
              time before the Project is published.
            </p>
          </li>
          <li>
            PROJECT STARTING DATE:
            <p>Refers to the commencement date of the Project.</p>
          </li>
          <li>
            PROJECT ENDING DATE:
            <p>
              Refers to the date on which the author of the Project decides to
              conclude the Project.
            </p>
          </li>
          <li>
            PROJECT INITIATOR:
            <p>
              The “Project Initiator” may also be referred to as the “Project
              Administrator.” It refers to the individual or entity that
              proposes or instigates the Project, invites other artists to join
              and contribute their skills and expertise. The Project Initiator
              often plays a key role in outlining the Project’s vision, goals,
              and initial direction, and they may also provide resources or
              leadership to ensure the Project’s successful execution.
            </p>
          </li>
          <li>
            PROJECT MESSAGE:
            <p>
              The Project message is the central theme guiding an art
              collaboration, conveying the collective vision and purpose of the
              participating artists.
            </p>
          </li>
          <li>
            PROJECT COLLAB SPACE:
            <p>
              After entering into a Collaboration Agreement, Collaborators will
              have access to a private collaboration space wherein they can
              access features and services offered by Sekeron for collaboration.
            </p>
          </li>
          <li>
            PROJECT CATEGORY:
            <p>
              Art collaboration projects can encompass a wide range of
              categories and styles, as they bring together artists with diverse
              skills and interests to work together on a common creative
              endeavor.Some common categories of art collaboration Projects
              include:
              <ol
                style={{
                  listStyleType: "lower-alpha",
                  marginLeft: "3rem",
                  marginTop: "2rem",
                }}
              >
                <li>Visual Art Collaboration</li>
                <li>Digital Media Collaboration</li>
                <li>Photography Collaboration</li>
                <li>Music and Visuals Collaboration</li>
                <li>Film Collaboration</li>
                <li>Literary and Visual Collaboration</li>
                <li>Performance Art Collaboration</li>
                <li>Sculpture Collaboration</li>
                <li>Textile and Fashion Collaboration</li>
                <li>Art and Technology Collaboration</li>
              </ol>
              <p>
                These are just a few examples, and the possibilities are
                virtually endless when it comes to art collaboration Projects.
                Sekeron shall be a service provider, enabler and a helping hand
                to all artistic collaborations.
              </p>
            </p>
          </li>
          <li>
            OWNER:
            <p>
              The term “owner” typically refers to the individual or entity that
              has the primary rights and control over the creative work
              resulting from the collaboration. The owner of the Project is the
              party who holds the legal and intellectual property rights
              associated with the Project.
            </p>
          </li>
          <li>
            REVENUE SPLIT:
            <p>
              The term refers to the division or allocation of the generated or
              to be generated income or proceeds from a collaborative Project.
              It will help establish the boundaries of revenue, such as sales,
              royalties, or licensing fees, which will be distributed amongst
              the participating artists in the manner described in clause 7.1.1
              of this Policy.
            </p>
          </li>
          <li>
            SOLO OWNER:
            <p>
              In a Collaboration Agreement between artists, the term "solo
              owner" typically refers to the individual who retains sole
              ownership of their respective work or intellectual property
              created during the collaboration. It means that any creative
              outputs or rights associated with their contributions remain under
              their exclusive ownership.
            </p>
          </li>
          <li>
            Type of Ownership:
            <p>As explained in clause 7.1.1 of this Policy.</p>
          </li>
          <li>
            VIEWER:
            <p>
              It refers to a user role within Sekeron designed for artists, who
              primarily has the capability to access and review artistic
              content, Projects, and creations contributed by collaborators.
              Unlike active contributors who may be artists themselves, a viewer
              typically focuses on observing, appreciating, and providing
              feedback on the creative works and Projects being developed within
              Sekeron.
            </p>
          </li>
        </ol>
        <h3>2. General Term:</h3>
        <ol
          style={{
            listStyleType: "lower-roman",
            marginLeft: "6rem",
            marginTop: "3rem",
          }}
        >
          <li>
            By accessing Sekeron, you confirm that you are in agreement with the
            terms and conditions as outlined in this Policy as well as the{" "}
            <span
              style={{
                fontWeight: "bold",
                textDecoration: "underline",
                fontStyle: "italic",
              }}
            >
              privacy policy, terms and conditions, and other policies of
              Sekeron.
            </span>
          </li>
          <li>
            Under no circumstances shall Sekeron be liable for any direct,
            indirect, special, incidental, or consequential damages, including,
            but not limited to, loss of data or profit, arising out of the use,
            or the inability to use, the materials on Sekeron, etc.
          </li>
          <li>
            Sekeron will not be responsible for any outcome that may occur
            during the course of usage of our resources.
          </li>
          <li>
            An amendment in a Collaboration Policy refers to a formal and
            documented change or modification made to the terms, conditions,
            provisions, or clauses of the original Collaboration Policy. This
            Policy may even be affected by a formal and documented change made
            to other policies and guidelines of Sekeron, and even by applicable
            laws of a country. By using Sekeron, the parties are consenting to
            the amendment of this Policy from time to time.
          </li>
          <li>
            The Privacy Policy of Sekeron, as updated from time to time, shall
            be read as part and parcel of this Policy.
          </li>
          <li>
            The Terms of Use of Sekeron, as updated from time to time, shall be
            read as part and parcel of this Policy.
          </li>
          <li>
            If Collaborators mutually agree on any of the terms which contradict
            this contract, the mutually agreed term between the Collaborators
            will prevail.
          </li>
          <li>
            In case of termination of the Collaboration Agreement, the
            Collaborators undertake to bear costs incurred up to termination and
            to split revenue collected, as discussed among themselves or
            otherwise as per the revenue split agreed upon in the Agreement.
          </li>
          <li>
            The Parties acknowledge and agree that all sensitive information and
            trade secrets shared during the collaboration shall be treated as
            confidential and shall not be disclosed to any third party without
            prior written consent. This obligation extends to protecting
            intellectual property, proprietary techniques, and confidential
            business information. Any breach of this confidentiality provision
            may result in legal remedies and damages as per the relevant
            provision under law.
          </li>
          <li>
            The Parties acknowledge that the Ex-Collaborator(s) shall retain
            their copyrights even after they have left the collaboration or as
            per what the Parties have mutually decided among themselves.
          </li>
        </ol>
        <h3>3. Scope of Collaboration Policy and Agreement:</h3>
        <p>
          The scope of Collaboration Agreement and Policy is intertwined with
          the activities of the users on Sekeron and is made for the process of
          streamlining Collaboration between artists.
        </p>
        <p>
          While the Collaboration Agreement comes into effect only when a user
          becomes part of a Project and in ordinary course of nature, terminates
          when the Project is ended. The Collaboration Agreement may also be
          affected by other activities of the Collaborators, which can be within
          or beyond the Project itself.
        </p>

        <p>
          The scope of Collaboration Agreement and Policy broadly includes:
          <ul style={{ marginLeft: "3rem", marginTop: "3rem" }}>
            <p>
              Projects: These Projects are meant for endeavors in the wide field
              of arts and are created by artists and creative people for
              collaborating. These Projects involve various creative outputs
              such as creation of artwork, performances, exhibitions, etc., with
              limitless possibilities.
            </p>
            <p>
              Roles and Responsibilities: Collaboration Agreement provides for
              the roles and responsibilities of each artist which shall be
              initially defined in the contract, encompassing tasks,
              contributions, and commitments. However, it is acknowledged that
              these roles and responsibilities, in the due course of this
              collaboration, are inherently dynamic and subject to change,
              whether implied or explicitly agreed upon.
            </p>
            <p>
              Duration Of Agreement: This Collaboration Agreement shall outline
              the commencement of the Project. Further, the termination date of
              this Agreement may or may not be specified and will be governed by
              the Termination Clause of Policy and Collaboration Agreement.
            </p>
            <p>
              Intellectual Property Rights: Parties involved in Collaboration
              acknowledge that all artistic works created during the course of
              the Project shall remain the exclusive property of the respective
              creators, subject to mutually agreed upon terms in the
              Collaboration Agreement.
            </p>
            <p>
              Financial Considerations: As for the financial considerations
              regarding the Project, Sekeron only provides the mechanism to log
              the information regarding Revenue Split as provided by the user
              interface of the Sekeron. Beyond logging revenue split
              information, Sekeron does not monitor or facilitate any other
              means of logging financial considerations in the Collaboration
              Agreement or facilitate financial transactions. Sekeron has no
              control and liability over any financial considerations decided
              amongst the collaborators or sharing thereof amongst the
              collaborators.
            </p>
            <p>
              Termination: This Policy outlines the grounds and conditions of
              Termination of the Collaboration
            </p>
          </ul>
        </p>

        <h3>4. Grant of License:</h3>
        <ol style={{ listStyleType: "lower-alpha", marginLeft: "4rem" }}>
          <li>
            Collaborators grants to Sekeron: Non-exclusive, non-transferrable
            right and license to receive the content and to:
            <ol
              style={{
                listStyleType: "upper-roman",
                listStylePosition: "inside",
                marginTop: "1rem",
              }}
            >
              <li>
                Distribute and/or exhibit the content to the Viewers via the
                Sekeron Platform.
              </li>
              <li>
                Permit the Viewers to access the content via the Sekeron
                Platform
              </li>
              <li>
                Communicate the content and the service through such mediums as
                Sekeron may require, including without limitation, through the
                service it operates; and
              </li>
              <li>
                Allow the Collaborators to download and upload any content
                related to collaboration.
              </li>
            </ol>
          </li>
          <li>
            Sekeron will have the right to reject the content if it is in
            violation to any of the policies of Sekeron.
          </li>
          <li>
            Sekeron will have the right to terminate Collaboration Agreement in
            accordance with this Policy.
          </li>
        </ol>
        <h3 style={{ marginTop: "6rem" }}>
          5. Rights of the Project Administrator/Initiator:
        </h3>
        <p>
          In a Collaboration Agreement, the administrative rights that a Project
          Initiator typically has can vary depending on the specific terms and
          conditions outlined in the Policy. However, some common administrative
          rights that a Project Initiator may have include, which shall only be
          practiced keeping in mind betterment of all Collaborators as well as
          the Project and not exercised in an unjust and arbitrary manner:
        </p>
        <p>
          Project Creation and Setup: The Project Initiator creates a new
          Project within Sekeron. The project may have optional or mandatory
          information for eg: title, description, and other relevant details to
          provide context for potential collaborators.
        </p>
        <p>
          Decision-Making Authority: The Project initiator has the authority to
          make key decisions regarding the Project's direction, scope, and
          objectives which may be decided before initiating the Project. They
          have the final say on important Project-related matters.
        </p>
        <p>
          Team Composition: The Project Initiator has the right to select or
          approve team members who will be involved in the collaborative
          Project.
        </p>
        <p>
          End Project: The Project administrator, on completion of the Project
          or otherwise, has the authority to conclude the collaboration.
        </p>
        <p>
          Removal of the Collaborator: The Project Initiator has the right to
          remove any of the Collaborators on the grounds as specifically
          mentioned under Clause 7.4 of this Collaboration Policy.
        </p>
        <p>
          Invitation to Collaborate: The Project initiator invites specific
          artists to join the Project. This can be done by sending invitations
          through Sekeron using the artists' usernames. Alternatively, Sekeron
          also has a searchable directory of artists, allowing Project
          initiators to browse and invite artists based on their profiles,
          skills, or previous work.
        </p>

        <h3>6. Intellectual Property Rights:</h3>
        <p>
          Intellectual Property Rights consists of the Economic rights and the
          Moral Rights in respect to the Collaboration. These Intellectual
          Property rights shall be shared among the Collaborators as defined in
          clause 7.2 of this Collaboration Policy.
        </p>
        <p>
          The following definitions of all rights are taken in a liberal manner
          in accordance with the international standards.
        </p>

        <h4 style={{ textDecoration: "underline" }}>
          The Economic Rights consists of the following rights:
        </h4>

        <ol
          style={{
            listStyleType: "upper-roman",
            marginLeft: "6rem",
            marginTop: "2rem",
          }}
        >
          <li>
            <strong>
              <u>Right of reproduction:</u>
            </strong>{" "}
            For the purpose of the Collaboration Agreement, the Right of
            Reproduction would mean making one or more copies of the
            Collaboration or of a substantial part of it in any material form,
            including sound and film recording.
          </li>
          <li>
            <strong>
              <u>Right to distribute:</u>
            </strong>{" "}
            A distribution right in copyright law gives the copyright owner
            exclusive control over how their work is distributed to the public.
            This includes the authority to distribute physical and digital
            copies, display the work publicly, and, in some cases, regulate
            importation.
          </li>
          <li>
            <strong>
              <u>Rental right:</u>
            </strong>{" "}
            The right of rental stems out of the right of distribution. ‘Rental’
            means making available for use for a limited period of time and for
            direct or indirect economic or commercial advantage.
          </li>
          <li>
            <strong>
              <u>Right of adaptation and translation:</u>
            </strong>{" "}
            The "adaptation right" grants copyright holders the exclusive
            authority to modify or create derivative works based on their
            original copyrighted content. This includes translations,
            adaptations, and other transformations into different forms or
            media. However, this right is subject to limitations and exceptions,
            such as fair use, which permit certain uses of copyrighted material
            without the copyright owner's consent. Similarly, the owner of a
            literary, dramatic, or musical work has the exclusive right to
            authorize the translation of his work. Translation means the
            expression of a work in a language other than that of the original
            version.
          </li>
          <li>
            <strong>
              <u>
                Rights of public performance and communication to the public:
              </u>
            </strong>
            The rights of public performance and communication to the public are
            fundamental aspects of copyright ownership. Public performance
            rights apply to literary, dramatic, and musical works, with
            particular significance for works designed for live dramatic or
            musical performances. This right allows the owner to authorize live
            presentations, such as plays, dances, or orchestra performances. On
            the other hand, the right to communicate the work to the public
            encompasses all protected work categories. It involves making the
            work or performance accessible to the public, whether through visual
            or auditory means, excluding the distribution of physical copies.
          </li>
        </ol>
        <h4 style={{ textDecoration: "underline" }}>
          The Moral Rights consists of the following rights:
        </h4>
        <ol
          style={{
            listStyleType: "upper-roman",
            marginLeft: "6rem",
            marginTop: "2rem",
          }}
        >
          <li>
            <strong>
              <u>Right of Paternity & Attribution:</u>
            </strong>{" "}
            The right to paternity is essentially the right of an author to
            claim authorship of his work and have it attributed to him. It is
            the right of an author to be identified whenever a work is
            published, performed, or broadcast. This means authors,
            scriptwriters, playwrights, painters, sculptors, illustrators, and
            translators must be properly credited for their works.
          </li>
          <li>
            <strong>
              <u>Right of Integrity:</u>
            </strong>{" "}
            The law grants the right to the author to object to any distortion,
            mutilation, modification, or other act which is prejudicial to his
            honour or reputation. The expression ‘other act’ is ejusdem generis
            with the words ‘distortion’ and ‘mutilation’. The failure to display
            a work at all and the failure to display it to the satisfaction of
            its author are not considered to be an infringement of the right of
            integrity.
          </li>
          <li>
            <strong>
              <u>Resale Share Right in Original Copies of Works:</u>
            </strong>{" "}
            This right is a special right which has features of both economic
            and moral rights. This right is economic in nature but available
            only to authors or their legal heirs. This is available in respect
            of the resale of the original copy of a painting, sculpture,
            drawing, or manuscript of a literary, dramatic, or musical work and
            shall be governed by the applicable laws of a country.
          </li>
        </ol>

        <h3>7. Flow of Collaboration</h3>

        <ul style={{ marginLeft: "3rem" }}>
          <h4>7.1 Creation of a Project</h4>
          <p>
            Sekeron is an application that serves as a collaborative platform
            for artists to connect, share ideas and work together on creative
            Projects. It enables users to create profiles, join or initiate
            collaborations, and communicate through messaging. Herein, the
            Project Initiator clicks on “NEW PROJECT” and starts filling in the
            details relating to the Project.
          </p>
          <p>
            After clicking on New Project, the Project Initiator will come
            across various options wherein he will have to fill and choose the
            details of the Project which will also help in determining the
            rights of the collaborators.
          </p>
          <p>
            The details will include Description of the Project, Project
            Category, Type of Copyright Ownership, Mode of Collaboration, any
            media related to the Project, Type, Requirement of Collaborators
            etc.
          </p>
          <h4>7.1.1 Scenarios/Ownership</h4>
          <p>
            At the onset of any Project, the Project Initiator shall be faced
            with four options of how to arrange the structure of his
            collaboration. These scenarios are technology enabled and cannot be
            amended to their fundamentals. However, certain modifications to
            this ‘right distribution technology enabled mechanism’ can be made
            by the Collaborators upon their discretion.
          </p>
          <p>The four scenarios are as follows:</p>
          <h4>SOLO- OWNER (EQUAL REVENUE SPLIT)</h4>
          <p>
            The Solo Owner with equal revenue split for the purpose of the
            Agreement would mean that only the Project Initiator will have the
            Economic Rights of the Project as explained in Clause 6 of this
            Policy, but the revenue gains out of the Collaboration will be
            distributed equally amongst all the Collaborators.
          </p>

          <h4>SOLO- OWNER (UNEQUAL REVENUE SPLIT)</h4>
          <p>
            The Solo Owner with unequal revenue split for the purpose of the
            Agreement would mean that only the Project Initiator will have the
            Economic Rights of the Project as explained in Clause 6 of this
            Policy, but the revenue gains out of the Collaboration will be
            distributed as per mutually decided amongst all the Collaborators.
          </p>

          <h4>CO- OWNER (EQUAL REVENUE SPLIT)</h4>
          <p>
            The Co-Owner with equal revenue split for the purpose of the
            Agreement would mean that all the Collaborators will have equal
            Economic Rights of the Project as explained in Clause 6 of this
            Policy, and revenue gains out of the Collaboration/Project will also
            be distributed equally among all the Collaborators.
          </p>

          <h4>CO- OWNER (UNEQUAL REVENUE SPLIT)</h4>
          <p>
            The Co-Owner with unequal revenue split for the purpose of the
            Agreement would mean that all the Collaborators will have equal
            Economic Rights of the Project as explained in Clause 6 of this
            Policy, but the revenue gains out of the Project will be distributed
            as per mutually decided amongst all the Collaborators.
          </p>

          <h4>7.2 ACCESS TO WORK SPACE(PROJECT COLLAB ROOM)</h4>
          <p>
            Upon completing the Creation of Project, the Collaborators shall
            have access to tools and services as offered by Sekeron, which may
            be updated from time to time.
          </p>
          <h4>7.3 ADDING AND INVITING ARTISTS</h4>
          <p>
            Adding an artist to a Project in Sekeron meant for the collaboration
            of artists typically involves a series of steps that facilitate
            communication, contribution, and coordination among the
            collaborators.
          </p>
          <h4>7.4 EXIT OF A COLLABORATOR(S)</h4>
          <p>
            The collaboration Policy outlines the following conditions under
            which the Project initiator can remove or a collaborator can
            withdraw from the Project.
          </p>

          <ol
            style={{
              listStyleType: "lower-roman",
              listStylePosition: "inside",
            }}
          >
            <li>
              <strong>Breach of contract:</strong> If any party fails to fulfill
              their obligations as outlined in this Policy or as mutually
              decided among the Collaborators, it could lead to the removal of
              the Collaborator by the Project Initiator. This may include not
              meeting deadlines, failing to deliver agreed-upon services, or not
              providing proper attribution.
            </li>
            <li>
              <strong>Non-performance or lack of contribution:</strong> If one
              party is not actively participating or contributing to the Project
              as expected, it shall be considered as a ground for termination,
              and the Project Initiator is entitled by the way of rights given
              to the Project Administrator as mentioned in Clause 5 to remove
              the Collaborator.
            </li>
            <li>
              <strong>Misconduct or unethical behavior:</strong> If any party
              engages in behavior that is considered unethical or damaging to
              the Project’s reputation, it could lead to termination.
            </li>
            <li>
              <strong>Creative differences:</strong> Disagreements over the
              objective, direction, style, manner, or content of the Project can
              sometimes become insurmountable, leading to a decision to
              terminate the Collaboration or removal of any Collaborator.
            </li>
            <li>
              <strong>Copyright Infringement:</strong> If there is any copyright
              infringement on the part of any of the Collaborators, then the
              Project Administrator has the right to remove that Collaborator,
              and if it is done by the Project Administrator, then Sekeron
              reserves the right to terminate the Project as it is in violation
              of the terms of use of Sekeron.
            </li>
            <li>
              <strong>Voluntarily:</strong> Any Collaborator, for whatsoever
              reason, can exit the Collaboration.
            </li>
            <li>
              <strong>Misrepresentation:</strong> If any of the Collaborators
              misrepresents in any form, then the Project Initiator reserves the
              right to remove that Collaborator from the Project.
            </li>
          </ol>
          <h4>7.5 Amendment:</h4>
          <p>
            Any change in Annexure-I of Collaboration Agreement will lead to the
            amendment of the Agreement.
          </p>
          <h4>7.6 Conclusion of Project:</h4>
          <p>
            The Project will stand concluded when it is completed or when all
            Parties involved may agree to terminate the collaboration for
            various reasons, such as changing personal circumstances, a shift in
            artistic vision, or business considerations.
          </p>
          <h4>7.7 Conflict Resolution:</h4>
          <p>
            Project initiator has a role to initially resolve disputes or
            disagreements that arise during the collaboration.
          </p>
          <p>
            It is essential for all parties involved in the collaboration to
            clearly define the administrative rights of the Project Initiator
            and the responsibilities and obligations of each collaborator. This
            ensures that the Project runs smoothly and that all parties are
            aware of their roles and contributions. A well-drafted collaboration
            agreement should address these rights and responsibilities
            comprehensively to avoid potential conflicts or misunderstandings
            during the Project's execution.
          </p>
        </ul>
        <h3>8. Termination of the Agreement:</h3>
        <p>
          This Collaboration Agreement will stand terminated in the following
          conditions:
        </p>
        <ul style={{ marginLeft: "3rem" }}>
          <p>
            By Sekeron: In case of violation of the Terms of this policy or any
            other policy of Sekeron, as amended from time to time and in case of
            where feels that the Project is in conflict with any law in force at
            that time or spirit of this platform.
          </p>
          <p>
            Force majeure: In some cases, events beyond the control of the
            parties, such as natural disasters or unforeseen circumstances, may
            make it impossible to continue the collaboration.
          </p>
          <p>
            By Administrator: Administrator has the power to terminate this
            contract as mentioned in the clause 5 of Policy.
          </p>
        </ul>
        <h3>9. Confidentiality and Non-Disclosure:</h3>
        <p>
          All the parties acknowledge that during the course of the
          collaboration, sensitive and confidential information may be shared.
          This includes, but is not limited to, musical compositions, lyrics,
          melodies, production techniques, marketing strategies, and any other
          proprietary information related to the Project.
        </p>
        <p>
          Each party undertakes to maintain the confidentiality of all such
          information and not to disclose it to any third party without the
          prior written consent of the other Collaborators. This obligation of
          confidentiality shall remain in effect during the term of
          Collaboration Agreement and for a period of 3 years thereafter.
        </p>
        <p>
          The parties further agree that any unauthorized disclosure or use of
          confidential information may result in irreparable harm for which
          monetary damages would be an inadequate remedy. Therefore, in the
          event of a breach of this confidentiality provision, the disclosing
          party shall be entitled to seek injunctive relief, in addition to any
          other remedies available under the law.
        </p>
        <p>
          This Non-Disclosure Undertaking is binding upon the parties and their
          respective successors, assigns, and representatives.
        </p>
        <p>
          This clause shall not be valid upon the Project Initiator who has
          opted for the Solo- Ownership but will be applicable on the rest of
          the Collaborators.
        </p>
        <p>
          The Collaborators acknowledge that since the Sekeron is not a party to
          Collaboration Agreement, no claim against any loss including the loss
          incurred by breach of this clause can be brought against Sekeron for
          any reason Whatsoever.
        </p>
      </p>
    </div>
  );
};
const CommunityGuidelines = () => {
  return (
    <div className={styles["collaboration-policy-container"]}>
      <p style={{ fontFamily: "Comfortaa", fontSize: "16px" }}>
        <h1>
          <span>COMMUNITY GUIDELINES</span>
        </h1>
        <p style={{ marginTop: "3rem" }}>
          We want Sekeron to be an authentic and safe place for inspiration and
          expression. Help us foster this community. Only post your own content
          and always follow the law.
        </p>
        <p>
          We created the Community Guidelines so you can help us foster and
          protect this amazing community. By using Sekeron, you agree to these
          guidelines and our Terms of Use. We&#39;re committed to these
          guidelines and we hope you are too. Overstepping these boundaries may
          result in deleted content, disabled accounts or other restrictions.
        </p>
        <p>
          The scope of Collaboration Policy for artists broadly encompasses the
          collaborative activities, roles, and goals. It includes creative
          projects, delineating roles and responsibilities, setting a timeline,
          addressing intellectual property rights, handling financial
          considerations, specifying termination and various other aspects. The
          same is elucidated upon further in Clause 3 of Policy.
        </p>
        <p>
          In some cases, we allow content for public awareness that would
          otherwise go against our Community Guidelines – if it is newsworthy
          and in the public interest. We do this only after weighing the public
          interest value against the risk of harm, and we look to international
          human rights standards to make these judgments.
        </p>
        <ol style={{ listStyleType: "disc", marginLeft: "3rem" }}>
          <li>
            <h4>Only share content that you&#39;ve have the right to share.</h4>
            <p>
              As always, you own the content that you post on Sekeron. Remember
              to post authentic content, and don&#39;t post anything you&#39;ve
              copied or collected from the Internet that you don&#39;t have the
              right to post.
            </p>
          </li>
          <li>
            <h4>
              Post photos and videos that are appropriate for a diverse
              audience.
            </h4>
            <p>
              We know that there are times when people might want to share nude
              images that are artistic or creative in nature, but for a variety
              of reasons, we don&#39;t allow nudity on Sekeron. This includes
              photos, videos and some digitally-created content that show sexual
              intercourse, genitals and close-ups of fully nude buttocks. It
              also includes some photos of female nipples, but photos in the
              context of breastfeeding, birth giving and after-birth moments,
              health-related situations (for example, post-mastectomy, breast
              cancer awareness or gender confirmation surgery) or an act of
              protest are allowed.
            </p>
            <p>
              People like to share photos or videos of their children. For
              safety reasons, there are times when we may remove images that
              show nude or partially nude children. Even when this content is
              shared with good intentions, it could be used by others in
              unanticipated ways.
            </p>
          </li>
          <li>
            <h4>Foster meaningful and genuine interactions.</h4>
            <p>
              Help us stay spam-free by not artificially collecting likes,
              followers or shares, posting repetitive comments or content, or
              repeatedly contacting people for commercial purposes without their
              consent. Don&#39;t offer money or giveaways of money in exchange
              for likes, followers, comments or other engagement. Don&#39;t post
              content that engages in, promotes, encourages, facilitates or
              admits to the offering, solicitation or trade of fake and
              misleading user reviews or ratings.
            </p>
            <p>
              You don&#39;t have to use your real name on Sekeron, but we do
              require Sekeron users to provide us with accurate and up-to-date
              information. Don&#39;t impersonate others and don&#39;t create
              accounts for the purpose of violating our guidelines or misleading
              others.
            </p>
          </li>
          <li>
            <h4>Follow the law.</h4>
            <p>
              Sekeron is not a place to support or praise terrorism, organised
              crime or hate groups. Offering sexual services, buying or selling
              firearms, alcohol and tobacco products between private
              individuals, and buying or selling non-medical or pharmaceutical
              drugs are also not allowed. We also remove content that attempts
              to trade, co-ordinate the trade of, donate, gift or ask for
              non-medical drugs, as well as content that either admits to
              personal use (unless in the recovery context) or coordinates or
              promotes the use of non-medical drugs. Sekeron also prohibits the
              sale of live animals between private individuals, though
              brick-and-mortar stores may offer these sales. No one may
              coordinate poaching or selling of endangered species or their
              parts.
            </p>
            <p>
              {" "}
              Remember to always follow the law when offering to sell or buy
              other regulated goods. Accounts promoting online gambling, online
              real money games of skill or online lotteries must get our prior
              written permission before using any of our products.
            </p>
            <p>
              We have zero tolerance when it comes to sharing sexual content
              involving minors or threatening to post intimate images of others.
            </p>
          </li>
          <li>
            <h4>Respect other members of the Sekeron community.</h4>
            <p>
              We want to foster a positive, diverse community. We remove content
              that contains credible threats or hate speech, content that
              targets private individuals to degrade or shame them, personal
              information meant to blackmail or harass someone, and repeated
              unwanted messages. We do generally allow stronger conversation
              around people who are featured in the news or have a large public
              audience due to their profession or chosen activities.
            </p>
            <p>
              It&#39;s never OK to encourage violence or attack anyone based on
              their race, ethnicity, national origin, sex, gender, gender
              identity, sexual orientation, religious affiliation, disabilities
              or diseases. When hate speech is being shared to challenge it or
              to raise awareness, we may allow it. In those instances, we ask
              that you express your intent clearly. Serious threats of harm to
              public and personal safety aren&#39;t allowed. This includes
              specific threats of physical harm as well as threats of theft,
              vandalism and other financial harm. We carefully review reports of
              threats and consider many things when determining whether a threat
              is credible.
            </p>
          </li>
          <li>
            <h4>
              Maintain our supportive environment by not glorifying self-injury.
            </h4>
            <p>
              The Sekeron community cares for each other, and is often a place
              where people facing difficult issues such as eating disorders,
              cutting or other kinds of self-injury come together to create
              awareness or find support.
            </p>
            <p>
              Encouraging or urging people to embrace self-injury is counter to
              this environment of support, and we&#39;ll remove it or disable
              accounts if this is reported to us. We may also remove content
              identifying victims or survivors of self-injury if the content
              targets them for attack or humour.
            </p>
          </li>
          <li>
            <h4>Be thoughtful when posting newsworthy events.</h4>
            <p>
              We understand that many people use Sekeron to share important and
              newsworthy events. Some of these issues can involve graphic
              images. Because so many different people and age groups use
              Sekeron, we may remove videos of intense, graphic violence to make
              sure that Sekeron stays appropriate for everyone.
            </p>
            <p>
              We understand that many people use Sekeron to share important and
              newsworthy events. Some of these issues can involve graphic
              images. Because so many different people and age groups use
              Sekeron, we may remove videos of intense, graphic violence to make
              sure that Sekeron stays appropriate for everyone.
            </p>
          </li>
        </ol>
        <h4>Help us keep the community strong:</h4>
        <ul
          style={{
            listStyleType: "disc",
            marginTop: "3rem",
            marginLeft: "3rem",
          }}
        >
          <li
            style={{
              marginTop: "1rem",
            }}
          >
            Each of us is an important part of the Sekeron community. If you see
            something that you think may violate our guidelines, please help us
            by informing us. We may remove entire posts if either the imagery or
            associated captions violate our guidelines.
          </li>
          <li
            style={{
              marginTop: "1rem",
            }}
          >
            You may find content you don&#39;t like, but doesn&#39;t violate the
            Community Guidelines. If that happens, you can unfollow or block the
            person who posted it. If there&#39;s something you don&#39;t like in
            a comment on one of your posts, you can delete that comment.
          </li>
          <li
            style={{
              marginTop: "1rem",
            }}
          >
            Many disputes and misunderstandings can be resolved directly between
            members of the community. If one of your photos or videos was posted
            by someone else, you could try commenting on the post and asking the
            person to take it down. If that doesn&#39;t work, you can file a
            copyright report. If you believe someone is violating your
            trademark, you can file a trademark report. Don&#39;t target the
            person who posted it by posting screenshots and drawing attention to
            the situation because that may be classified as harassment.
          </li>
          <li
            style={{
              marginTop: "1rem",
            }}
          >
            We may work with law enforcement, including when we believe that
            there&#39;s risk of physical harm or threat to public safety.
          </li>
        </ul>
        <p></p>
        <p>
          Thank you for helping us create one of the best communities in the
          world, The Sekeron Team
        </p>
      </p>
    </div>
  );
};
const CollaborationAgreement = () => {
  return (
    <div className={styles["collaboration-policy-container"]}>
      <p style={{ fontFamily: "Comfortaa", fontSize: "16px" }}>
        <h1>
          <span>COLLABORATION AGREEMENT</span>
        </h1>
        <p style={{ marginTop: "3rem" }}>
          This Collaboration Agreement <strong>(“Agreement”)</strong> is
          executed on and By and Amongst the parties as mentioned in{" "}
          <strong>ANNEXURE-1</strong> of this Agreement.
        </p>
        <p>Whereas:</p>

        <ol style={{ listStyleType: "lower-alpha", marginLeft: "3rem" }}>
          <li>
            <p>
              Sekeron is a social media web and mobile application (Hereinafter
              shall be referred to as <strong>“Sekeron”</strong>) created for
              artists of all disciplines to improvise communication and
              collaboration among the creative community. With a vibrant and
              supportive community, it serves as an intermediary which provides
              an inspiring space where artists can connect, share ideas, and
              collaborate seamlessly on diverse art projects. Whether painters,
              photographers, musicians, writers, or any creative mind, Sekeron
              empowers artists to unleash their creativity and explore new
              artistic horizons together. Sekeron encourages an engaging and
              ever-expanding network of collaborative artists, fostering
              innovation and artistic growth.
            </p>
          </li>
          <li>
            <p>Project Initiator has initiated a new project on Sekeron.</p>
          </li>
          <li>
            <p>
              The Project Initiator is in requirement of Collaborator(s) to
              accomplish the Project.
            </p>
          </li>
          <li>
            <p>
              The Project Initiator and Collaborator(s) are entering into a
              collaboration as per the terms specified in this Agreement and
              Sekeron’s Collaboration Policy (which forms a part of this
              Agreement) as updated from time to time, to accomplish the
              Project.
            </p>
          </li>
          <li>
            <p>
              In pursuance of the stipulation as mentioned above, the Project
              Initiator and Collaborator(s) (hereinafter together be referred as
              “Parties”) executes the present Agreement.
            </p>
          </li>
        </ol>
        <h4>NOW THEREFORE THESE PRESENTS WITNESSETH AS FOLLOWS:</h4>
        <ol
          style={{
            listStyleType: "number",
            marginTop: "3rem",
            marginLeft: "3rem",
          }}
        >
          <li
            style={{
              marginTop: "1rem",
            }}
          >
            <h3>Definition:</h3>
            <p>
              All capitalized terms, unless otherwise defined herein, shall have
              the same meaning given to them in the Collaboration policy.
            </p>
            <p>
              <strong>“Project ID” </strong>means a unique identification number
              provided by Sekeron to every Project.
            </p>
            <p>
              <strong>“Project Mode”</strong> means the mode by which the
              Project Collaboration occurs, whether online, offline, or in a
              hybrid format.
            </p>

            <p>
              <strong>“Project Location”</strong> or{" "}
              <strong>“Project Address"</strong>
              means the primary location where the project could either be
              performed or practiced, or any other relevant activity for the
              collaboration when the project mode is offline or hybrid.
            </p>
            <p>
              <strong>“Username”</strong> shall mean the name selected by a user
              to be displayed on the Sekeron to the other users.
            </p>
            <p>
              <strong>“User ID”</strong> means a unique identification number
              provided by the Sekeron to each user.
            </p>
            <p>
              <strong>“Joining Date”</strong> means a date on which the
              Collaborator joins the Project.
            </p>
            <p>
              <strong>“Leaving Date”</strong> means the date upon which the
              Collaborator leaves the Project or is removed by the Project
              Initiator.
            </p>
            <p>
              <strong>“Future Revenue Split”</strong> means the percentage of
              revenue a Collaborator is entitled from the revenue earned from
              the Project.
            </p>
            <p>
              <strong>“Skill(s)”</strong> means the skill(s) contributed by the
              Collaborator in the Project
            </p>
            <p>
              <strong>“Skill(s)”</strong> means the skill(s) contributed by the
              Collaborator in the Project
            </p>
            <p>
              <strong>“Terms Accepted” </strong> means the accepted terms by a
              Collaborator before Joining the Project proposed by the Project
              Initiator
            </p>
          </li>
          <li style={{ marginTop: "1rem" }}>
            <h3>Project Details:</h3>
            <p>
              The Project is initiated by the Project Initiator. The details of
              the Project are disclosed in <strong>Schedule B</strong> of this
              Agreement.
            </p>
          </li>
          <li style={{ marginTop: "1rem" }}>
            <h3>Scope:</h3>
            <p>
              Subject to the terms and conditions of this Agreement, the Parties
              shall collaborate in a manner, and shall perform their respective
              duties, as set out in but not limited to{" "}
              <strong>Schedule C</strong> of this Agreement.
            </p>
          </li>
          <li style={{ marginTop: "1rem" }}>
            <h3>Term:</h3>
            <p>
              The present Agreement shall come into force on as mentioned under
              “Starting Date” under <strong>Schedule B</strong> of this
              Agreement and shall be in force unless terminated by either of the
              Parties in terms of this Agreement or on as mentioned under “End
              Date” under <strong>Schedule B</strong> of this Agreement.
            </p>
          </li>
          <li style={{ marginTop: "1rem" }}>
            <h3>Law and Jurisdiction:</h3>
            <p>
              This Agreement shall be governed by and construed in accordance
              with the laws of country as consented by the parties to the
              dispute or the laws of India. Any dispute, controversy, or claim
              arising out of or relating to this Agreement, shall be resolved
              through negotiation in good faith between the Parties. If the
              Parties are unable to resolve the dispute through negotiation
              within 30 days after either party has given written notice to the
              other party describing the nature of the dispute, the dispute
              shall be submitted to the exclusive jurisdiction of the courts
              where the parties to the dispute consent to or the courts of New
              Delhi, India shall have the jurisdiction over such disputes. All
              the parties hereby consent to the personal jurisdiction of said
              courts and agree that any legal action, suit, or proceeding
              arising out of or relating to this Agreement shall be brought
              solely in the aforementioned courts. Parties of this Agreement
              acknowledges that Sekeron is not a party to this contract,
              therefore no claim against any kind of loss can be made against
              the Sekeron. Also, in any legal action where the Sekeren is made
              party to, the Parties agree that the courts of New Delhi, India
              shall have the exclusive jurisdiction over such legal action.
            </p>
          </li>
          <li style={{ marginTop: "1rem" }}>
            <h3>Confidentiality and Non-Disclosure:</h3>
            <p>
              All the parties acknowledge that during the course of the
              collaboration, sensitive and confidential information may be
              shared. This includes, but is not limited to, musical
              compositions, lyrics, melodies, production techniques, marketing
              strategies, and any other proprietary information related to the
              project. Each party undertakes to maintain the confidentiality of
              all such information and not to disclose it to any third party
              without the prior written consent of the other Collaborators. This
              obligation of confidentiality shall remain in effect during the
              term of this collaboration agreement and for a period of 3 years
              thereafter. The parties further agree that any unauthorized
              disclosure or use of confidential information may result in
              irreparable harm for which monetary damages would be an inadequate
              remedy. Therefore, in the event of a breach of this
              confidentiality provision, the disclosing party shall be entitled
              to seek injunctive relief, in addition to any other remedies
              available under the law. This Non-Disclosure Undertaking is
              binding upon the parties and their respective successors, assigns,
              and representatives.
            </p>
          </li>
          <li style={{ marginTop: "1rem" }}>
            <h3>Communication between Parties:</h3>
            <p>
              The Parties to this Agreement shall communicate with each other
              through Sekeron only. In case of dispute among the Parties, the
              Sekeron upon its own discretion will share the communication
              details and collaboration details of the other Parties as per the
              information entered by them during registration, if required.
            </p>
          </li>
          <li style={{ marginTop: "1rem" }}>
            <h3>Termination of the Agreement:</h3>
            <p>
              This Agreement will stand terminated in the following conditions:
              <ol
                style={{
                  listStyleType: "lower-alpha",
                  marginTop: "2rem",
                  marginLeft: "2rem",
                }}
              >
                <li>
                  By Sekeron: In case of violation of the Terms of this
                  agreement and in case of where feels that the project is in
                  conflict with any law in force at that time or spirit of this
                  platform.
                </li>
                <li>
                  Force majeure: In some cases, events beyond the control of the
                  parties, such as natural disasters or unforeseen
                  circumstances, may make it impossible to continue the
                  collaboration.
                </li>
                <li>
                  By Project Initiator: The Project Initiator has the power to
                  terminate this contract as mentioned in the clause 5 of the
                  Policy.
                </li>
              </ol>
            </p>
          </li>
          <li style={{ marginTop: "1rem" }}>
            <h3>No Liability:</h3>
            <p>
              Under no circumstances shall Sekeron be liable for any direct,
              indirect, special, incidental or consequential damages, including,
              but not limited to, loss of data or profit, arising out of the
              use, or the inability to use, the materials on Sekeron etc.
            </p>
          </li>
        </ol>
        <img src={anex1} style={{ width: "100%" }} />
        <img src={anex2} style={{ width: "100%" }} />
      </p>
    </div>
  );
};

const PrivacyPolicy = () => {
  return (
    <div className={styles["privacy-policy"]}>
      <p style={{ fontFamily: "Comfortaa", fontSize: "16px" }}>
        <h1>
          <span>Privacy Policy</span>
        </h1>
        <p>
          Sekeron is a social media web and mobile application (Hereinafter
          shall be referred to as<span>“Sekeron”</span> or<span>“We”</span> )
          created for artists of all disciplines to improvise communication and
          collaboration among the creative community. With a vibrant and
          supportive community, it serves as an intermediary which provides an
          inspiring space where artists can connect, share ideas, and
          collaborate seamlessly on diverse art projects. Whether painters,
          photographers, musicians, writers, or any creative mind, Sekeron
          empowers artists to unleash their creativity and explore new artistic
          horizons together. Sekeron encourages an engaging and ever-expanding
          network of collaborative artists, fostering innovation and artistic
          growth.
        </p>
        <p>
          On Sekeron, users can register themselves and use various features of
          the app like creating a project, uploading posts, messaging other
          users, etc. The Privacy Policy will explain how Sekeron uses,
          collects, share, retain and transfer information collected from users.{" "}
        </p>
        <p>
          This Privacy Policy is a part of and is to be read with the{" "}
          <a href="/terms-and-conditions">Terms Of Use</a>
          <span>("Terms")</span> . By using this Platform, you agree to the
          terms and conditions of this Privacy Policy. You also consent to our
          use and disclosure of your Personal Information (as defined below) in
          the manner described in this Privacy Policy. If you do not agree with
          the terms and conditions of this Privacy Policy, please do not use
          this Platform.
        </p>
        <h5>Topics</h5>
        <ul>
          <li style={{ listStyleType: "decimal" }}>What data do we collect?</li>
          <li style={{ listStyleType: "decimal" }}>
            How do we collect your data?
          </li>
          <li style={{ listStyleType: "decimal" }}>
            How do we store your data ?
          </li>
          <li style={{ listStyleType: "decimal" }}>
            How will we use your data?
          </li>
          <li style={{ listStyleType: "decimal" }}>Marketing.</li>
          <li style={{ listStyleType: "decimal" }}>
            How do we share information with third parties?
          </li>
          <li style={{ listStyleType: "decimal" }}>How can you manage</li>
          <li style={{ listStyleType: "decimal" }}>
            How long do we keep your information?
          </li>
          <li style={{ listStyleType: "decimal" }}>
            How will you know that our policy has changed?
          </li>
          <li style={{ listStyleType: "decimal" }}>
            How to contact Sekeron for grievance or question?
          </li>
          <li style={{ listStyleType: "decimal" }}>
            What are your data protection rights?
          </li>
          <li style={{ listStyleType: "decimal" }}>
            Changes to our privacy policy
          </li>
          <li style={{ listStyleType: "decimal" }}>How to contact us?</li>
          <li style={{ listStyleType: "decimal" }}>
            How to contact appropriate authorities?
          </li>
        </ul>
        <h5>What data do we collect?</h5>
        The information we collect and process about you depends on how you use
        our services. For example, we collect different information if you just
        post a photograph on Sekeron compared to if you enter into a
        collaboration agreement for a project. When you use our platform, we
        collect some information about you even if you don’t have an account.
        <h5>Here’s the information that we collect:</h5>
        <h4>
          Information we collect and receive if you use or interact with our
          Products but don’t have an account:
        </h4>
        Even if you don’t have an account, we collect things like:-
        <li style={{ listStyleType: "lower-alpha" }}>
          Browser and app logs of your visits to public content
        </li>
        <li style={{ listStyleType: "lower-alpha" }}>
          Basic information about devices that downloaded Sekeron, like device
          model and operating system. Examples of why we collect and receive
          information:
          <li style={{ listStyleType: "lower-alpha" }}>
            Security of our Products:
            <p>
              For example, we collect information to monitor attempted attacks
              on our systems, such as overloading our servers with traffic.
              Also, if we see someone without an account trying to load too many
              pages, they could be trying to Scrape our website in violation of
              our terms. Then we can take action to prevent it.
            </p>
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            Safety and integrity:
            <p>
              For example, if someone shares a harmful video, we can take action
              according to our Community Standards. We can remove content that
              violates our terms and policies or share information with law
              enforcement when we believe there is a genuine risk of death or
              imminent bodily harm.
            </p>
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            Performance:
            <p>
              For example, we collect information when people use our services,
              even if they don’t have an account, to measure how fast our pages
              load in different countries and whether they're working properly.
              This helps us identify and fix issues with local networks.
            </p>
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            Advertisement.
            <p>
              For example, if someone shares a harmful video, we can take action
              according to our Community Standards. We can remove content that
              violates our terms and policies or share information with law
              enforcement when we believe there is a genuine risk of death or
              imminent bodily harm.
            </p>
          </li>
        </li>
        <h5>Your activity and information you provide:</h5>
        On our platform, you can send messages, share files Collaborate and much
        more. We call all of the things you can do on our platform as
        “activity”. We collect your activity across our platform and information
        you provide, such as:
        <ul>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Details for registration of an user on Sekeron. These include the
            following:
            <ul>
              <li style={{ listStyleType: "upper-roman" }}>
                {" "}
                Email ID of the user or the Facebook account details, if the
                user wishes to login through Facebook.
              </li>
              <li style={{ listStyleType: "upper-roman" }}>
                {" "}
                Data received from Google or Facebook.
              </li>
              <li style={{ listStyleType: "upper-roman" }}>
                {" "}
                One Time Password ("OTP") sent to the registered email
              </li>
              <li style={{ listStyleType: "upper-roman" }}>
                {" "}
                of the User for the verification purpose of Email ID.
              </li>
              <li style={{ listStyleType: "upper-roman" }}>
                {" "}
                Personal information of the user. For eg. full name of the user,
                gender, date of birth, phone number, and skills as entered by
                the user.
              </li>
              <li style={{ listStyleType: "upper-roman" }}>
                {" "}
                Optional information. For eg. education information,
                location/address for the purpose of personalised
                recommendations, links of social media accounts or any other
                information as provided by the user.
              </li>
            </ul>
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Interests as provided by the user or information received via
            Cookies. Learn more about Cookie Policy.
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Information of project created by user. This will include project
            name, project category, copyright ownership, future revenue split,
            start and end date, address and location (if the project is offline
            or hybrid), your skills for the project, details/requirements of the
            other artists required or any other information of the project as
            provided by the user.
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Content you create, like posts, comments, audio, etc.
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Content you provide through our camera feature or your phone’s
            gallery, or through our voice-enabled features.
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Messages you send and receive, including their content, subject to
            applicable laws.
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Types of content, including ads, you review or interact with, and
            how you interact with it.
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Features you use, and what actions you take in them.
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Purchases or other transactions you make, including mode of payment
            information.
          </li>
          <li style={{ listStyleType: "lower-alpha" }}> Hashtags you use.</li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            The time, frequency and duration of your activities on our platform
          </li>
        </ul>
        <p style={{ textDecoration: "underline" }}>
          Friends, followers and other connections:
        </p>
        <p>
          We collect information about friends, followers, groups, accounts and
          other users and communities you’re connected to and interact with.
          This includes how you interact with them across our Platform and which
          ones you interact with the most.
        </p>
        Information we collect about contacts:
        <p>
          We also collect your contact’s information, such as their name and
          email address or phone number if you choose to upload or import it
          from a device. For eg. By synching contacts and address book with
          Sekeron.
        </p>
        <p>
          We collect information about you based on other’s activity. For eg. We
          may suggest a friend to you may know, if you both appear on a contact
          list that someone uploads
        </p>
        <p style={{ textDecoration: "underline" }}>
          {" "}
          App, browser and device information:
        </p>
        We collect and receive information from and about the different devices
        you use and how you use them. Device information we collect and receive
        includes:
        <ul>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            The device and software you’re using, and other device
            characteristics.
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            What you’re doing on your device, like whether our app is in the
            foreground or if your mouse is moving (which can help tell humans
            from bots)
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Identifiers that tell your device apart from other users’, including
            Family Device IDs.
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Signals from your device.
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Information you’ve shared with us through device settings, like GPS
            location, camera access, photos and other.
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Information about the network you connect your device to and your
            connection, including your IP Address.
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Some location-related information, even if Location Services is
            turned off in your device settings. This includes using IP addresses
            to estimate your general location.
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Information about our Products’ performance on your device.
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Information from cookies and similar technologies.{" "}
          </li>
        </ul>
        <p style={{ textDecoration: "underline" }}>
          Information from partners, vendors and other third parties:
        </p>
        <p>
          We collect and receive information from partners, measurement vendors,
          marketing vendors and other third parties about a variety of your
          information and activities on and off our Platform.
        </p>
        Here are some examples of information we receive about you:
        <ul>
          <li style={{ listStyleType: "lower-alpha" }}>
            Your device information.
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Websites you visit and cookie data
          </li>
          <li style={{ listStyleType: "lower-alpha" }}> Apps you use.</li>
          <li style={{ listStyleType: "lower-alpha" }}> Games you play.</li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Purchases and transactions you make off of our Platform.
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Your demographics, like your education level
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            The ads you see and how you interact with them
          </li>
        </ul>
        <p style={{ textDecoration: "underline" }}>
          What if you don’t let us collect certain information?
        </p>
        <p>
          Some information is required for our activities to work. Other
          information is optional, but without it, the quality of your
          experience might be affected. For example, if you don’t provide an
          email address or phone number, we won’t be able to create an account
          for you to use our services.
        </p>
        <h5>How do we collect your data ?</h5>
        You directly provide Sekeron with most of the data we collect. We
        collect and process data when you:
        <li>Use Sekeron</li>
        <li>Register yourself with Sekeron.</li>
        <li>
          Voluntarily complete a customer survey or provide feedback on any of
          our message boards or via email.
        </li>
        <li>Use or view our website via your browser’s cookies.</li>
        Sekeron may also receive your data indirectly from following resources:
        <li>
          Sekeron may receive your name, phone number and email ID from your
          friends profile, if they choose to upload or import it from a device.
          For eg. By synching contacts and address book with Sekeron.
        </li>
        <li>We collect and rece</li>
        <h4>How do we store your data ?</h4>
        We store your data with Amazon Web Services cloud platform provided by
        Amazon Web Services, Inc. (headquartered at 410 Terry Ave. N Seattle,
        Washington 98109, USA) and also on Google Cloud Platform provided by
        Google LLC (headquartered at 1101 S Flower St, Burbank, California
        91502, USA) on their servers located in India and abroad. Both Amazon
        Web Services and Google Cloud Platform implement security measures to
        protect the loss, misuse and alteration of the information, details of
        which are available at <a href="https://aws.amazon.com">
          aws.amazzon
        </a>{" "}
        and <a href="https://cloud.google.com">cloud.google</a> The privacy
        policies adopted by Amazon Web Services and Google Cloud Platform are
        available at{" "}
        <a href="https://policies.google.com/privacy">Google Policies</a> and{" "}
        <a href="https://aws.amazon.com/privacy">Amazon Policies</a>
        <h3>How will we use your data?</h3>
        We use information we collect to provide a personalized experience to
        you, including ads, along with other purposes we explain in detail
        below.
        <p>
          For some of these purposes, we use information across our platform and
          across your devices. The information we use for these purposes is
          automatically processed by our systems. But in some cases, we also use
          manual review to access and review your information.
        </p>
        <p>
          To use less information that’s connected to individual users, in some
          cases we deidentify or aggregate information or anonymize it so that
          it no longer identifies you. We use this information in the same way
          we use your information as described in this section
        </p>
        Here are ways we use your information:
        <ul>
          <p style={{ textDecoration: "underline" }}>
            To provide, personalize and improve our services:
          </p>
          <p>
            We use information we have to provide and improve our services. This
            includes personalizing features, content and recommendations.
          </p>
          <p>
            We’re always trying to make our Products better and create new ones
            with the features you want. Information we collect from you helps us
            learn how.
          </p>
          We use information we collect to:
          <ul>
            <li style={{ listStyleType: "lower-alpha" }}>
              {" "}
              See if a product is working correctly.
            </li>
            <li style={{ listStyleType: "lower-alpha" }}>
              {" "}
              Troubleshoot and fix it when it’s not.
            </li>
            <li style={{ listStyleType: "lower-alpha" }}>
              {" "}
              Test out new products and features to see if they work.
            </li>
            <li style={{ listStyleType: "lower-alpha" }}>
              {" "}
              Get feedback on our ideas for products or features.
            </li>
            <li style={{ listStyleType: "lower-alpha" }}>
              {" "}
              Conduct surveys and other research about what you like about our
              Products and brands and what we can do better.
            </li>
          </ul>
        </ul>
        <ul>
          <p style={{ textDecoration: "underline" }}>
            How we use location-related information?
          </p>
          <p>
            We use location-related information that you allow us to receive if
            you turn on the Location Services device setting. This includes
            things like your GPS location and, depending on the operating system
            you're using, other device signals.
          </p>
          <p>
            We also receive and use some location-related information even if
            Location Services is turned off. This includes:
          </p>
          <ul>
            <li>
              {" "}
              IP addresses, which we use to estimate your general location. We
              can use IP addresses to estimate your specific location if it’s
              necessary to protect the safety and security of you or others.
            </li>
            <li>
              Information you give us directly, like if you enter your current
              city on your profile, etc.
            </li>
            We use location-related information, such as your current location,
            where you live, the places you like to go and the businesses and
            people you're near, to:
            <li>
              Provide, personalize and improve our Products, including ads, for
              you and others.
            </li>
            <li>
              {" "}
              Detect suspicious activity and help keep your account secure.
            </li>
          </ul>
        </ul>
        <p style={{ textDecoration: "underline" }}>To communicate with you:</p>
        <p>
          We communicate with you using information you have given us, like
          contact information you have entered on your profile.
        </p>
        <p style={{ textDecoration: "underline" }}>
          To research and innovate for social good:
        </p>
        <p>
          We use information we have, information from researchers and datasets
          from publicly available sources, professional groups and non-profit
          groups to conduct and support research.
        </p>
        <h3>Marketing:</h3>
        Sekeron would like to send you information about products and services
        of ours that we think you might like.
        <h3>Cookies:</h3>
        Sekeron uses cookies to distinguish you from other users of our
        Platform. This helps us to provide you with a good user experience when
        you browse our Platform and also allows us to improve the Platform. We
        collect the cookie data from the cookies on your device. For detailed
        information on the cookies we use and the purposes for which we use
        them, kindly see our <span>cookie policy</span>
        <h3>How do we share information with third parties?</h3>
        We don’t sell any of our information to anyone. We also require third
        parties to be in compliance with law in force while using and disclosing
        the information we provide.
        <p>Here’s more detail about who we share information with:</p>
        <p style={{ textDecoration: "underline" }}>Service Providers:</p>
        Service providers provide services to us that help us provide our
        Products to you. We share the information we have about you to receive
        these services, which include:
        <ul>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Investigating suspicious activity.
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Detecting and stopping threats to our personnel and property.
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Facilitating payments.
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Providing customer support.
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Improving the functionality of our Products.
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Providing technical infrastructure services.
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Analyzing how our Products are used.
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Conducting research and surveys.
          </li>
          <li style={{ listStyleType: "lower-alpha" }}>
            {" "}
            Marketing and promoting our services.
          </li>
        </ul>
        <p style={{ textDecoration: "underline" }}>Other Third Parties:</p>
        <p>
          We also share information with other third parties in response to
          legal requests, to comply with applicable law or to prevent harm. And
          if we sell or transfer all or part of our business to someone else, in
          some cases we will give the new owner your information as part of that
          transaction, but only as the law allows.
        </p>
        <h5>
          How can you manage or delete your information and exercise your
          rights?
        </h5>
        We offer you a variety of tools to view, manage and delete your account.
        You can also manage your information by visiting the settings of the
        products you use. You may have other privacy rights under applicable
        laws. For more information, please check the link{" "}
        <a href="/data-deletion-policy">User Data Deletion Policy</a>
        <h5>How long do we keep your information?</h5>
        We keep information as long as we need it to provide our services,
        comply with legal obligations or protect our or other’s interests. We
        decide how long we need information on a case-by-case basis. Here’s what
        we consider when we decide:
        <li> If we need to operate or provide our products.</li>
        <li>
          {" "}
          The feature we use it for, and how that feature works. For eg.
          Messages sent using messenger’s vanish mode are retained for less time
          than regular messages.
        </li>
        <li>
          {" "}
          How long we need to retain the information to comply with certain
          legal obligations.
        </li>
        <li>
          {" "}
          If we need it for other legitimate purposes, such as to prevent harm;
          investigate possible violations of our terms or policies; promote
          safety, security and integrity; or protect ourselves, including our
          rights, property or services.
        </li>
        In some instances and for specific reasons, we will keep information for
        an extended period of time. Your information, including financial
        transaction data related to purchases or money transfers made on our
        Products, may be preserved and accessed for a longer time period if it’s
        related to any of the following:
        <li>
          {" "}
          A legal request or obligation or to comply with applicable law.
        </li>
        <li> A governmental investigation.</li>
        <li>
          {" "}
          An investigation of possible violations of our terms or policies.
        </li>
        <li> To prevent harm.</li>
        <li> For safety, security and integrity purposes.</li>
        <li>
          {" "}
          To protect ourselves, including our rights, property or products.
        </li>
        <li>
          g. If it’s needed in relation to a legal claim, complaint, litigation
          or regulatory proceedings.
        </li>
        <h5>How will you Know the policy has changed?</h5>
        We will notify you before we make material changes to this policy. You
        will have the opportunity to review the revised policy before you choose
        to continue using our products.
        <h5>How to Contact Sekeron with questions?</h5>
        We have a Grievance Officer to address your concerns regarding data
        safety, privacy, and the Platform usage concerns. We will resolve the
        issues raised by you within 15 (fifteen) days from receiving them. You
        may contact our grievance officer at the following email address: Email
        Id: Support@sekeron.com
      </p>
    </div>
  );
};
export {
  TermsAndConditions,
  PrivacyPolicy,
  CollaborationPolicy,
  CommunityGuidelines,
  CollaborationAgreement,
};
